module.exports = __webpack_public_path__ + "static/media/bsm-logo-single-transparent.f7b64c35.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bsm-logo-single-transparent.png
// module id = 437
// module chunks = 0